import { render, staticRenderFns } from "./AgreeTermsForm.vue?vue&type=template&id=bddb7bb4&scoped=true&"
import script from "./AgreeTermsForm.vue?vue&type=script&lang=ts&"
export * from "./AgreeTermsForm.vue?vue&type=script&lang=ts&"
import style0 from "./AgreeTermsForm.vue?vue&type=style&index=0&id=bddb7bb4&scoped=true&lang=css&"
import style1 from "./AgreeTermsForm.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bddb7bb4",
  null
  
)

export default component.exports